<template>
  <div class="maintenance" :style="{height:screenHighet+'px'}">
    <div>
        <h1>未找到页面</h1>
      <!-- <h2>点击返回上一页</h2> -->
    </div>
  </div>
</template>

<script>

export default {
  name: 'maintenance',
  data () {
    return {
      screenHighet: document.documentElement.clientHeight - 280 // 屏幕宽度
    }
  },
  methods: {

  },
  mounted () {
    var _this = this
    window.onresize = function () {
      // 定义窗口大小变更通知事件
      _this.screenHighet = document.documentElement.clientHeight - 280 // 窗口宽度
    }
  },
  components: {}
}
</script>

<style lang="scss">
.maintenance{
  width: 92vw;
  display: flex;
  div{
    margin: auto;
  }

}

</style>



// WEBPACK FOOTER //
// src/view/maintenance.vue